import ifElse from 'ramda/src/ifElse'
import always from 'ramda/src/always'

export default ifElse(always(EXPORT))



// WEBPACK FOOTER //
// ./src/helpers/ifExport.js